import { MonogramBadge } from './monogram-badge.js';

export function LoginMobileHeader() {
  return (
    <div className="relative overflow-hidden bg-neutral-900 px-6 pb-14 pt-10 text-white lg:hidden">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-16 -right-16 size-48 rounded-full bg-white/5 blur-2xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 left-0 size-32 rounded-full bg-white/10 blur-xl"
      />

      <div className="relative flex flex-col gap-4">
        <MonogramBadge />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Nudool</h1>
          <p className="mt-2 max-w-xs text-sm leading-relaxed text-neutral-300">
            ERP and business management built for modern teams.
          </p>
        </div>
      </div>
    </div>
  );
}
